/**
 * @generated SignedSource<<7d4102cd2e1abcc25893362b426ace13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedAuctionPriceDisplay$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionSubscription_item" | "PriceDisplay_item" | "useAuctionPricing_item" | "useAuctionState_item">;
  readonly " $fragmentType": "PdpSharedCondensedAuctionPriceDisplay";
};
export type PdpSharedCondensedAuctionPriceDisplay$key = {
  readonly " $data"?: PdpSharedCondensedAuctionPriceDisplay$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedAuctionPriceDisplay">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedAuctionPriceDisplay",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionSubscription_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionState_item"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "ac2baee6277c50748e22c4c07bd28875";

export default node;
